import { Icon } from "@iconify/react/dist/iconify.js";
import React, { useState } from "react";
import {
  formatDate,
  formatShortScheduleListDate,
} from "../../../helpers/dateFormatter";
import { calculateTotalPrice } from "../../../helpers/calculateTotalPrice";
import { calculatePaxSummary } from "../../../helpers/calculatePaxSummary";
import ConfirmRedeemModal from "../modal/ConfirmRedeemModal";
import { Link } from "react-router-dom";

const FBookingCard = ({ booking, handleRedeem, isPostMarkAsRedeemLoading }) => {
  const [showConfirmRedeemModal, setShowConfirmRedeemModal] = useState(false);
  return (
    <div
      className={`fp-booking-card flex-1 ${
        booking?.status?.toLowerCase() === "completed" ? "redeemed" : ""
      }`}
    >
      <div className="d-flex align-items-start justify-content-between">
        <div className="flex-grow-0 flex-shrink-1 flex-1 fp-booking-card-info">
          <Link
            className="m-0 fp-bc-booking-id-link"
            to={`/bookings/${booking?.voucher_number}`}
          >
            <div>
              <p className="m-0 fp-bc-booking-id d-flex align-items-center">
                {booking?.voucher_number}
                {booking?.status?.toLowerCase() === "completed" && (
                  <Icon
                    icon="bitcoin-icons:verify-filled"
                    width={30}
                    height={30}
                    color="#01A236"
                  />
                )}
              </p>

              <p className="m-0 fp-bc-booking-text">
                <Icon
                  icon="mdi:calendar-month"
                  color="#eb662b"
                  fontSize={17}
                  className="me-1"
                />
                {formatShortScheduleListDate(booking?.trip_date)}
              </p>
              <h5 className="my-2 fp-bc-title">
                {booking?.product?.product_title}
              </h5>
              <div className="d-flex mb-2 gap-3">
                <p className="m-0 fp-bc-booking-text">
                  <span>Lead Traveler:</span> {booking?.customer?.customer_name}
                </p>
                <p className="m-0 fp-bc-booking-text">
                  <span>No. of Travelers: </span>
                  {calculatePaxSummary(booking?.lineItems)}
                </p>
              </div>
              <Link
                className="m-0 fp-bc-booking-id-link-view-details "
                to={`/bookings/${booking?.voucher_number}`}
              >
                View details
              </Link>
            </div>
          </Link>
        </div>
        <div className="flex-1  flex-shrink-0 fp-booking-card- flex-column d-flex align-items-end justify-content-end">
          <div className="d-flex align-items-center gap-2 mb-2">
            <div className="fp-bc-booking-amount">
              Your amount:{" "}
              <span> AED {Math.floor(parseInt(booking?.total_amount))}</span>
            </div>
            {booking?.status?.toLowerCase() !== "pending" &&
              booking?.status?.toLowerCase() !== "inprogress" && (
                <button
                  className={
                    booking?.status?.toLowerCase() !== "completed"
                      ? "fp-booking-redeemed-btn"
                      : "fp-booking-redeem-now-btn"
                  }
                  onClick={() => {
                    if (
                      booking?.status?.toLowerCase() !== "completed" &&
                      new Date() <= new Date(booking?.trip_date)
                    ) {
                      setShowConfirmRedeemModal(true);
                    }
                  }}
                >
                  {booking?.status?.toLowerCase() === "completed"
                    ? "Redeemed"
                    : new Date() > new Date(booking?.trip_date)
                    ? "Expired"
                    : "Redeem Now"}
                </button>
              )}
            {booking?.status?.toLowerCase() === "pending" &&
              booking?.status?.toLowerCase() === "inprogress" && (
                <div className="fp-booking-status-p-inp-btn">
                  {booking?.status?.toLowerCase() === "pending"
                    ? "Pending"
                    : "In Progress"}
                </div>
              )}
          </div>
          {booking?.status?.toLowerCase() === "completed" && (
            <p className="m-0 fp-bc-booking-text">
              <span>Redeem date: </span>Aug 25, 2024
            </p>
          )}
        </div>
      </div>
      {/* Confirm Redeem Modal */}
      <ConfirmRedeemModal
        show={showConfirmRedeemModal}
        handleClose={() => setShowConfirmRedeemModal(false)}
        listItemsLength={`${booking?.voucher_number}`}
        isLoading={isPostMarkAsRedeemLoading}
        handleRedeem={async () => {
          await handleRedeem([{ id: booking?.order_id, checked: true }]);
          setShowConfirmRedeemModal(false);
        }}
      />
    </div>
  );
};
export default FBookingCard;
